// ======================================================================
// File Name       : ContentQuestionEditSelectType
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Col, FormControl, Form } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import TableHead from '../../components/TableHead';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import SelectBox from '../../components/SelectBox';
import FormControlValidate from '../FormControlValidate';
import { VALIDATE_TYPE } from '../../constants/index';
import { ANSWER_FORMULA } from '../../constants/ContentConstant';

class ContentQuestionEditSelectType extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onCheckBox = this.onCheckBox.bind(this);
    this.validation = this.validation.bind(this);
  }
  onChange(event, data) {
    if (data === undefined) {
      const { name, value } = event.target;
      this.props.onInputChange(name, value);
    } else {
      this.props.onInputChange(event, data);
    }
  }
  onCheckBox(event) {
    this.props.onCheckBoxChange(event);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    const {
      optionMarkKind,
      onInputChange,
      onShowDialogBtnClick,
      optionRandomUse,
      answerInfo,
      questionUseForm,
    } = this.props;
    let {
      answerFormula,
    } = this.props;
    this.refsToValidate = [];
    const correctAnswerNumberList = [];
    const isQuestionUseForm = questionUseForm == '1';
    const correctAnswerList = [];
    answerFormula = answerFormula ? answerFormula.toString() : '0';

    if (answerInfo && answerInfo.length > 0) {
      for (let i = 0; i < answerInfo.length; i++) {
        if (answerInfo[i].correctAnswerNumber) {
          correctAnswerNumberList.push(answerInfo[i].correctAnswerNumber);
        }
        // get correct answer list
        if (answerInfo[i].isCorrectAnswer) {
          correctAnswerList.push(answerInfo[i].answerChoice);
        }
      }
    }
    return (
      <Form className='form-horizontal'>
        <Col sm={12}>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col sm={4} as={Form.Label}>
                解答方式
              </Col>
              <Col sm={7}>
                <SelectBox
                  data={SELECT_BOX_DATA.ANSWER_FORMULA}
                  name="answerFormula"
                  value={answerFormula}
                  onChange={this.onChange}
                  required
                  label="解答方式"
                />
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col sm={4} as={Form.Label}>
                選択肢記号種別
              </Col>
              <Col sm={7}>
                <SelectBox
                  data={SELECT_BOX_DATA.OPTION_MARK_TYPE}
                  name="optionMarkKind"
                  value={optionMarkKind}
                  onChange={this.onChange}
                  label="選択肢記号種別"
                />
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col sm={4} className="col-sm-4" as={Form.Label}>
                選択肢をランダムに表示する
              </Col>
              <Col sm={3} className="padding-top-7" >
                <Form.Check
                  type='checkbox'
                  className="margin-left-30"
                  checked={optionRandomUse}
                  name="optionRandomUse"
                  id="optionRandomUse"
                  onChange={this.onCheckBox} />
              </Col>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col sm={12} className="padding-left-right-clear">
              <Col sm={4} as={Form.Label}>
                選択肢
                {!isQuestionUseForm ?
                  <span className="required">&nbsp;(※)</span>
                  : null
                }
              </Col>
              <Col sm={3}>
                <Button
                  variant="primary"
                  className="btn-96"
                  onClick={onShowDialogBtnClick}
                >
                  追加
                </Button>
              </Col>
              {!isQuestionUseForm && <Col
                sm={{
                  span: 7,
                  offset: 4
                }}
                hidden={answerInfo.length > 0}>
                <FormControlValidate
                  label="選択肢"
                  validateType={VALIDATE_TYPE.LABEL}
                  value={answerInfo.length ? answerInfo.length : ''}
                  required
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>}
              {!isQuestionUseForm &&
                answerInfo && answerInfo.length &&
                (answerFormula === ANSWER_FORMULA.SELECTIVE_SORT_ANSWER ||
                answerFormula === ANSWER_FORMULA.SELECTIVE_SINGLE_ANSWER ||
                answerFormula === ANSWER_FORMULA.SELECTIVE_MULTIPLE_ANSWER) ?
                  <Col
                    as={Form.Label}
                    sm={{
                      span: 7,
                      offset: 4
                    }}>
                    <FormControlValidate
                      label={'正答情報'}
                      validateType={VALIDATE_TYPE.MIN_ANSWER_LIST}
                      value={answerInfo || []}
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                    />
                  </Col>
                : null }
              {(answerFormula === ANSWER_FORMULA.SELECTIVE_SORT_ANSWER &&
                !isQuestionUseForm &&
                answerInfo && answerInfo.length) ?
                  <Col
                    as={Form.Label}
                    sm={{
                      span: 7,
                      offset: 4
                    }}>
                    <FormControlValidate
                      label={'正答情報'}
                      validateType={VALIDATE_TYPE.QUESTION_ANSWER}
                      value={correctAnswerNumberList || []}
                      ref={(ref) => {
                        if (ref) {
                          this.refsToValidate.push(ref);
                        }
                      }}
                    />
                  </Col> : null}
              {/* Validate question SELECTIVE_SINGLE_ANSWER is only have 1 correct answe */}
              {!isQuestionUseForm &&
              (answerFormula === ANSWER_FORMULA.SELECTIVE_SINGLE_ANSWER) &&
              answerInfo && answerInfo.length ?
                <Col
                  as={Form.Label}
                  sm={{
                    span: 7,
                    offset: 4
                  }}>
                  <FormControlValidate
                    label="選択肢"
                    validateType={VALIDATE_TYPE.QUESTION_SELECTIVE_SINGLE_ANSWER}
                    value={correctAnswerList || []}
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                  />
                </Col>
              : null}
            </Col>
          </Form.Group>
        </Col>
      </Form>
    );
  }
}

export default ContentQuestionEditSelectType;
